import { render, staticRenderFns } from "./fl223-proposal-show.vue?vue&type=template&id=7a8e226a&scoped=true&"
import script from "./fl223-proposal-show.vue?vue&type=script&lang=js&"
export * from "./fl223-proposal-show.vue?vue&type=script&lang=js&"
import style0 from "./fl223-proposal-show.vue?vue&type=style&index=0&id=7a8e226a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8e226a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8e226a')) {
      api.createRecord('7a8e226a', component.options)
    } else {
      api.reload('7a8e226a', component.options)
    }
    module.hot.accept("./fl223-proposal-show.vue?vue&type=template&id=7a8e226a&scoped=true&", function () {
      api.rerender('7a8e226a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/proposals/fl223-proposal-show.vue"
export default component.exports